// extracted by mini-css-extract-plugin
export default {"toggle":"DarkMode_toggle__0L2cP"};